import React from 'react';
import './SectionHeading.css';

/**
 * Section header with a mono eyebrow label and a display title.
 * Wrap the highlighted part of the title in `accent`.
 */
export default function SectionHeading({ eyebrow, title, accent, align = 'center' }) {
  return (
    <div className={`section-heading section-heading--${align}`}>
      {eyebrow && <span className="section-heading__eyebrow">{eyebrow}</span>}
      <h2 className="section-heading__title">
        {title} {accent && <span className="gradient-text">{accent}</span>}
      </h2>
    </div>
  );
}
